<script>
import mixinComponent from '../../../Mixins/mixinComponent'
import SimpleGroupSelect from '../Form/SimpleGroupSelect.vue'

export default {
  components: { SimpleGroupSelect },
  mixins: [mixinComponent],
  props: {
    submenuLabels: {
      type: Array,
      default: [],
    },
    status: {
      type: [String, Number],
      default: '0',
    },
    centered: {
      type: Boolean,
      default: true,
    },
  },

  computed: {
    submenuLinkClass() {
      return {
        'submenu-link': true,
        'centered-submenu': this.centered,
      }
    },
    items() {
      return this.submenuLabels.filter((item) => item.visible ?? true)
    },
  },

  methods: {
    setActive(value) {
      this.$emit('update:status', value)
    },
    getMenuClasses(value) {
      const firstIndex = 0
      const lastIndex = this.submenuLabels.length - 1

      return {
        'mr-1': value === firstIndex,
        'm-1': ![firstIndex, lastIndex].includes(value),
        'ml-1': value === lastIndex,
        'sub-active': value === Number(this.status),
      }
    },
  },
}
</script>
<template>
  <div class="d-flex">
    <div class="submenu-select">
      <SimpleGroupSelect
        :label-text="$t('contract.list.type.label')"
        :config-options="submenuLabels"
        :model-value="status"
        @transmitted="setActive"
      >
      </SimpleGroupSelect>
    </div>

    <div :class="submenuLinkClass">
      <template v-for="item in items" :key="item.id">
        <a
          :class="getMenuClasses(item.id)"
          :e2e-button="'menu-' + item.id"
          :tabindex="item.id"
          @click="setActive(item.id)"
        >
          {{ item.name }}
        </a>
      </template>
    </div>
    <div>
      <slot></slot>
    </div>
  </div>
</template>
